/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const SortOrderUpIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Sort Order Up',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <g>
      <rect x="2" y="8" width="12" height="4" rx="1" />
      <rect x="2" y="16" width="16" height="4" rx="1" />
      <rect x="2" y="24" width="20" height="4" rx="1" />
      <path
        d="M31.999 12h-2.006v15a.988.988 0 0 1-.987 1h-.992a1 1 0 0 1-1-.999L27.007 12h-2.006a.5.5 0 0 1-.501-.504.489.489 0 0 1 .147-.35l3.537-4.033a.5.5 0 0 1 .632 0l3.537 4.033a.489.489 0 0 1 .147.35.5.5 0 0 1-.501.504Z"
      />
    </g>
  </svg>`;
};
